<div class="stretch-height">
    <eil-top-nav *ngIf="this.showNav" id="topNav"></eil-top-nav>
    <div (touchmove)="this.displayNavBarMobile($event)" (wheel)="this.showNavBar($event)"
         class='container-fluid stretch-height'
         id="container">
        <div class='row stretch-height'>
            <div class='col-sm-12 body-content stretch-height'>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
